import React, { useState, useEffect } from 'react';
import { Wallet, ChevronDown, Twitter, Plus, Minus, Loader } from 'lucide-react';
import { Web3Button } from '@thirdweb-dev/react';
import { ThirdwebSDK } from '@thirdweb-dev/sdk';

const NFTMintingPlatform = () => {
  // ===== STATE DECLARATIONS =====
  const [selectedCollection, setSelectedCollection] = useState(0);
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  const [mintAmount, setMintAmount] = useState(1);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [showWalletOptions, setShowWalletOptions] = useState(false);
  const [isMinting, setIsMinting] = useState(false);
  const [currentChainId, setCurrentChainId] = useState(null);
  const [supplies, setSupplies] = useState({});
  const [isLoadingSupply, setIsLoadingSupply] = useState(false);
  const [notification, setNotification] = useState(null);


           

  // ===== COLLECTIONS DATA =====
const collections = [
  // BASE CHAIN (3 collections)
  { 
    name: 'Just Mint on Base #1', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmadJw7foKKno3i5woq5Cj3tUx4udBCvE7x4KK97Zze7cB/0.jpg',
    chain: 'base', 
    chainId: '0x2105',
    tokenId: 0,
    contractKey: 'base-cyberpunks'
  },
  { 
    name: 'Just Mint on Base #2', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmNhQKrvUJHHp8m5D383YJQCfppv8WotVk6er7RBMHGUzx/0.jpg',
    chain: 'base', 
    chainId: '0x2105',
    tokenId: 0,
    contractKey: 'base-mysticmasks'
  },
  { 
    name: 'Just Mint on Base #3', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmfPbhf64SbMrUcqQXbTwAqu37KWr2Z7UBJ4HTDhhDq412/0.jpg',
    chain: 'base', 
    chainId: '0x2105',
    tokenId: 0,
    contractKey: 'base-oceanguardians'
  },
  
  // UNICHAIN (2 collections)
  { 
    name: 'Just Mint on Unichain #1', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmXfvtmFefu75bvr99DxszrgFZHMxmMgV7mtwfZjYDHFRf/0.jpg',
    chain: 'unichain', 
    chainId: '0x515',
    tokenId: 0,
    contractKey: 'unichain-cosmicapes'
  },
  { 
    name: 'Just Mint on Unichain #2', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmYdpqqMamTTnBTjn2PBVT1NGVEUdEdtHU8ffVPGacirtx/0.jpg',
    chain: 'unichain', 
    chainId: '0x515',
    tokenId: 0,
    contractKey: 'unichain-unicornlegends'
  },
  
  // ZERO NETWORK (2 collections)
  { 
    name: 'Just Mint on Unichain #3', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmXyGhaEGngNUc5iW6QoFD3souUaqPG5dzGbLZZjuQAm1f/0.jpg',
    chain: 'unichain', 
    chainId: '0x515',
    tokenId: 0,
    contractKey: 'zero-digitaldragons'
  },
  { 
    name: 'Just Mint on Ink #1', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmcrAzNqa2tGaExmJX8RaHJNnLWPSQRmn58C5Gyt1b4Dkq/0.jpg',
    chain: 'ink', 
    chainId: '0xdef1',
    tokenId: 0,
    contractKey: 'zero-voidwalkers'
  },
  
  // INK (2 collections)
  { 
    name: 'Just Mint on Ink #2', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmW9fyR8TiVsAHdY7zpLJQwtX6PgqnkoCqGMQ18gtSFkj3/0.jpg',
    chain: 'ink', 
    chainId: '0xdef1',
    tokenId: 0,
    contractKey: 'ink-pixellegends'
  },
  { 
    name: 'Just Mint on Ink #3', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmWzwknZPJUdjxFip2EMGRKYzuidmwSdu2nvE8XdZgYWZH/0.jpg',
    chain: 'ink', 
    chainId: '0xdef1',
    tokenId: 0,
    contractKey: 'ink-inkmasters'
  },
  
  // DEBANK CHAIN (2 collections)
  { 
    name: 'Just Mint on DeBank #1', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmPk7cG5Q8tQf7zvQWmtGNWLt4BivAsY54XyyC5ZzxmL9t/0.jpg',
    chain: 'debank', 
    chainId: '0x7e9',
    tokenId: 0,
    contractKey: 'debank-neosamurai'
  },
  { 
    name: 'Just Mint on DeBank #2', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmZru6CjQxrTUsEifu9ZYDm9TMEYbctrJoQdZQG7fjYqz1/0.jpg',
    chain: 'debank', 
    chainId: '0x7e9',
    tokenId: 0,
    contractKey: 'debank-crystalkeepers'
  },
  
  // SONEIUM (1 collection)
  { 
    name: 'Just Mint on DeBank #3', 
    price: '0.0001 ETH',
    supply: '100,000', 
    image: 'https://8b644159d353c604102c2977ea80390d.ipfscdn.io/ipfs/QmZvPfEohhXBY9ELY1zzXRosLgygtATtxf2KCKgePwAJk6/0.jpg',
    chain: 'debank', 
    chainId: '0x7e9',
    tokenId: 0,
    contractKey: 'soneium-galaxywarriors'
  }
];



  const chains = {
    base: { name: 'Base', color: 'from-blue-600 to-blue-700', rpcUrl: 'https://mainnet.base.org' },
    unichain: { name: 'Unichain', color: 'from-pink-500 to-purple-600', rpcUrl: 'https://mainnet.unichain.org' },
    zero: { name: 'Zero Network', color: 'from-red-900 to-red-700', rpcUrl: 'https://rpc.zero.network' },
    ink: { name: 'Ink Chain', color: 'from-indigo-700 to-purple-600', rpcUrl: 'https://rpc-gel.inkonchain.com' },
    debank: { name: 'DeBank Chain', color: 'from-orange-500 to-orange-800', rpcUrl: 'https://rpc.dbank.io' },
    soneium: { name: 'Soneium', color: 'from-gray-600 to-gray-500', rpcUrl: 'https://rpc.soneium.org' }
  };

  const contractAddresses = {
    // BASE (3 contracts)
    'base-cyberpunks': '0x4f811C9Ba60AD79286745Ec49ca17450ad480202',
    'base-mysticmasks': '0x2eB5BEE1d01A7839B6146a82ACB7831180AEaD7f',
    'base-oceanguardians': '0x1046EDc7A91857888249166a21eDAc496C4299f9',
    // UNICHAIN (2 contracts)
    'unichain-cosmicapes': '0xaE7F62a5F4713FD889D598b2Ac37D39e7a59226D',
    'unichain-unicornlegends': '0xb6418438EBF7682bfd53B1298700c8E223b53cB9',
    // ZERO (2 contracts)
    'zero-digitaldragons': '0xb46cedBC583A438575B58EdD605cE3bcDeA0024f',
    'zero-voidwalkers': '0x1a0e29A88e40653ffe617cC03f0cEe92bDC71bBA',
    // INK (2 contracts)
    'ink-pixellegends': '0x00FF3fbC621932782fE71bc157FA688845a235e4',
    'ink-inkmasters': '0x9BDa99449088FCc1D481BdF11347cf3c7932f196',
    // DEBANK (2 contracts)
    'debank-neosamurai': '0x0996Cd2C934B3286146eF0721a6bCc1E4D640e87',
    'debank-crystalkeepers': '0x5aE4dBd42bD564f3404f85704C97fD5a1dA3f20D',
    // SONEIUM (1 contract)
    'soneium-galaxywarriors': '0x0796cC6EA8A16791Da3D1dc456A6Ebd1Bc5B315d'
  };

  const faqs = [
    {
      q: 'What is JUST Mint ?',
      a: 'The major function of JUST MiNT platform is that it provides minting NFTs services . It allows users to mint NFT asset in different Layer 2 chains.'
    },
    {
      q: 'Which wallets are supported ?',
      a: 'We support MetaMask and WalletConnect, which allows you to connect with hundreds of different wallet providers including Trust Wallet, Rainbow, Coinbase Wallet, and more.'
    },
    {
      q: 'How much does it cost to mint ?',
      a: 'The minting price is JUST 0.0001 ETH. Additionally, you\'ll need to pay gas fees which depend on network congestion at the time of minting.'
    },
    {
      q: 'Why should i use JUST MiNT ?',
      a: 'Generate transactions in L2 chains, interact with different smart contract L2 chains, future rewards.'
    },
    {
      q: 'What can I do with my NFT after minting ?',
      a: 'Once minted, you can hold your NFT in your wallet, trade it on secondary marketplaces, or hold it for future rewards.'
    },
    {
      q: 'When JUST MiNT token ?',
      a: 'Not planned. we are just started.'
    }
  ];

  // ===== HELPER FUNCTIONS =====
  const getChainId = (chainKey) => {
    const chainIdMap = {
      base: 8453,
      unichain: 1301,
      zero: 543210,
      ink: 57073,
      debank: 2025,
      soneium: 1868
    };
    return chainIdMap[chainKey] || 8453;
  };

  const switchNetwork = async (chainId) => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: chainId }],
        });
        return true;
      } catch (error) {
        if (error.code === 4902) {
          alert('This network is not added to your wallet. Please add it manually.');
        }
        return false;
      }
    }
    return false;
  };

    
  
  
  
  
  
const addNetwork = async (chainKey) => {
  const networkConfigs = {
    base: {
      chainId: '0x2105',
      chainName: 'Base',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://mainnet.base.org'],
      blockExplorerUrls: ['https://basescan.org']
    },
    unichain: {
      chainId: '0x515',
      chainName: 'Unichain',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://mainnet.unichain.org'],
      blockExplorerUrls: ['https://uniscan.xyz']
    },
    zero: {
      chainId: '0x84942',
      chainName: 'Zero Network',
      nativeCurrency: { name: 'ZERO', symbol: 'ZERO', decimals: 18 },
      rpcUrls: ['https://rpc.zero.network'],
      blockExplorerUrls: ['https://zeroscan.org']
    },
    ink: {
      chainId: '0xdef1',
      chainName: 'Ink',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://rpc-gel.inkonchain.com'],
      blockExplorerUrls: ['https://explorer.inkonchain.com']
    },
    debank: {
      chainId: '0x7e9',
      chainName: 'DeBank Chain',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://rpc.dbank.io'],
      blockExplorerUrls: ['https://explorer.dbank.io']
    },
    soneium: {
      chainId: '0x74c',
      chainName: 'Soneium',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://rpc.soneium.org'],
      blockExplorerUrls: ['https://soneium.org/explorer']
    }
  };

  const config = networkConfigs[chainKey];
  
  if (!config) {
    console.error('Unknown chain:', chainKey);
    return false;
  }

  try {
    await window.ethereum.request({
      method: 'wallet_addEthereumChain',
      params: [config]
    });
    return true;
  } catch (error) {
    console.error('Error adding network:', error);
    return false;
  }
};








  // ===== WALLET FUNCTIONS =====
  const checkWalletConnection = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          setWalletAddress(accounts[0]);
          setIsWalletConnected(true);
          const chainId = await window.ethereum.request({ method: 'eth_chainId' });
          setCurrentChainId(chainId);
        }
      } catch (error) {
        console.error('Error checking wallet connection:', error);
      }
    }
  };

  const handleAccountsChanged = (accounts) => {
    if (accounts.length === 0) {
      setIsWalletConnected(false);
      setWalletAddress('');
    } else {
      setWalletAddress(accounts[0]);
      setIsWalletConnected(true);
    }
  };

  const connectMetaMask = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setWalletAddress(accounts[0]);
        setIsWalletConnected(true);
        setShowWalletOptions(false);
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        setCurrentChainId(chainId);
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
        alert('Failed to connect to MetaMask. Please try again.');
      }
    } else {
      alert('MetaMask is not installed. Please install MetaMask to continue.');
      window.open('https://metamask.io/download/', '_blank');
    }
  };

  const connectWalletConnect = async () => {
    alert('WalletConnect integration requires additional setup. For now, please use MetaMask.');
    setShowWalletOptions(false);
  };

  const disconnectWallet = () => {
    setIsWalletConnected(false);
    setWalletAddress('');
    setCurrentChainId(null);
  };





  
  
  // ===== MINTING FUNCTION =====
       
      const handleMint = async () => {
  if (!isWalletConnected) {
    alert('Please connect your wallet first!');
    return;
  }

  const collection = collections[selectedCollection];
  const chain = chains[collection.chain];
  
  setIsMinting(true);
  
  try {
    console.log('=== STARTING MINT ===');
    console.log('Collection:', collection.name);
    console.log('Chain:', chain.name);
    
    const { ethers } = await import('ethers');
    
    // Check current network
    const currentChain = await window.ethereum.request({ method: 'eth_chainId' });
    console.log('Current chain:', currentChain);
    console.log('Expected chain:', collection.chainId);
    
    if (currentChain.toLowerCase() !== collection.chainId.toLowerCase()) {
      console.log('⚠️ Wrong network - attempting auto switch...');
      
      // Try to switch network
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: collection.chainId }],
        });
        console.log('✅ Network switched successfully!');
        
        // Small delay to let MetaMask update
        await new Promise(resolve => setTimeout(resolve, 1000));
        
      } catch (switchError) {
        console.error('Switch error:', switchError);
        
        // Error code 4902 means the chain hasn't been added yet
        if (switchError.code === 4902) {
          console.log('Network not found, attempting to add...');
          
          const added = await addNetwork(collection.chain);
          
          if (added) {
            console.log('✅ Network added successfully!');
            alert(`✅ ${chain.name} network added to MetaMask!\n\nPlease click Mint again.`);
          } else {
            alert(`❌ Failed to add ${chain.name} network.\n\nPlease add it manually in MetaMask.`);
          }
          
          setIsMinting(false);
          return;
          
        } else if (switchError.code === 4001) {
          // User rejected the request
          alert('❌ Network switch cancelled by user.');
          setIsMinting(false);
          return;
          
        } else {
          // Other error
          alert(`❌ Failed to switch network: ${switchError.message}`);
          setIsMinting(false);
          return;
        }
      }
    }
    
    console.log('✅ On correct network');
    
    // Connect wallet
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    
    console.log('✅ Wallet connected');
    
    // Get chain ID as number
    const chainIdNumber = parseInt(collection.chainId, 16);
    
    // Initialize SDK
    const sdk = ThirdwebSDK.fromSigner(signer, chainIdNumber, {
      clientId: process.env.REACT_APP_THIRDWEB_CLIENT_ID
    });
    
    console.log('✅ SDK initialized');
    
    // Get contract
    const contractAddress = contractAddresses[collection.contractKey];
    console.log('Contract:', contractAddress);
    
    if (!contractAddress || contractAddress.startsWith('0xYour')) {
      alert('❌ Contract not deployed yet for this collection!');
      setIsMinting(false);
      return;
    }
    
    const contract = await sdk.getContract(contractAddress, 'edition');
    
    console.log('✅ Contract loaded');
    console.log('Claiming', mintAmount, 'NFT(s)...');
    
    // Claim NFTs
    const tx = await contract.erc1155.claim(collection.tokenId, mintAmount);
    
    console.log('✅ Transaction successful!');
    console.log('Hash:', tx.receipt.transactionHash);
    
    alert(`✅ Successfully minted ${mintAmount} ${collection.name} NFT(s)!\n\nTransaction: ${tx.receipt.transactionHash}`);
    
    // Refresh supply
    await fetchSupply(selectedCollection);
    
  } catch (error) {
    console.error('=== ERROR ===');
    console.error(error);
    
    let errorMsg = 'Minting failed';
    
    if (error.message.includes('insufficient funds')) {
      errorMsg = 'Insufficient ETH for NFT price + gas fees';
    } else if (error.code === 4001 || error.message.includes('user rejected')) {
      errorMsg = 'Transaction cancelled by user';
    } else if (error.reason) {
      errorMsg = error.reason;
    } else {
      errorMsg = error.message;
    }
    
    alert(`❌ ${errorMsg}`);
    
  } finally {
    setIsMinting(false);
  }
};




                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      


  // ===== FETCH SUPPLY FUNCTION =====
  const fetchSupply = async (collectionIndex) => {
    try {
      const collection = collections[collectionIndex];
      const contractAddress = contractAddresses[collection.contractKey];
      
      if (!contractAddress || contractAddress.startsWith('0xYour')) {
        return;
      }

      const chainIdNumber = parseInt(collection.chainId, 16);
      
      const sdk = new ThirdwebSDK(chainIdNumber, {
        clientId: process.env.REACT_APP_THIRDWEB_CLIENT_ID
      });
      
      const contract = await sdk.getContract(contractAddress, 'edition');
      const totalMinted = await contract.erc1155.totalSupply(collection.tokenId);
      
      console.log(`${collection.name}: ${totalMinted.toString()} minted`);
      
      setSupplies(prev => ({
        ...prev,
        [collectionIndex]: totalMinted.toString()
      }));
      
    } catch (error) {
      console.error('Error fetching supply:', error);
    }
  };

  // ===== USE EFFECTS =====
  useEffect(() => {
    checkWalletConnection();
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
      window.ethereum.on('chainChanged', () => window.location.reload());
    }
    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      }
    };
  }, []);

  useEffect(() => {
    const loadAllSupplies = async () => {
      setIsLoadingSupply(true);
      for (let i = 0; i < collections.length; i++) {
        await fetchSupply(i);
      }
      setIsLoadingSupply(false);
    };
    
    const hasContracts = Object.values(contractAddresses).some(
      addr => addr && !addr.startsWith('0xYour')
    );
    
    if (hasContracts) {
      loadAllSupplies();
    }
  }, []);

  // ===== JSX RENDER =====
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-black text-white">
      {/* Header */}
      <header className="border-b border-purple-500/20 backdrop-blur-sm bg-black/20 sticky top-0 z-50">
  <div className="container mx-auto px-4 py-4 flex justify-between items-center">
    <div className="flex items-center gap-3">
      <img 
        src="/logo.png" 
        alt="JUST MiNT Logo" 
        className="w-30 h-20 object-contain"
      />
      <span className="text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
        
      </span>
    </div>
      
                                                
          
          <div className="flex items-center gap-4">
            <a href="https://x.com/justmint_nft" target="_blank" rel="noopener noreferrer" 
               className="p-2 hover:bg-white/10 rounded-lg transition flex items-center gap-2 text-sm">
              <Twitter className="w-5 h-5" />
              <span className="hidden sm:inline">Follow Us</span>
            </a>
            
            {isWalletConnected ? (
              <div className="relative group">
                <button className="px-4 py-2 bg-green-500/20 border border-green-500 rounded-lg flex items-center gap-2 hover:bg-green-500/30 transition">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-sm">{walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}</span>
                </button>
                <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-purple-500/30 rounded-lg shadow-xl overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                  <button 
                    onClick={disconnectWallet}
                    className="w-full px-4 py-3 hover:bg-red-500/20 transition text-left text-red-400">
                    Disconnect Wallet
                  </button>
                </div>
              </div>
            ) : (
              <div className="relative">
                <button 
                  onClick={() => setShowWalletOptions(!showWalletOptions)}
                  className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg font-semibold hover:scale-105 transition flex items-center gap-2">
                  <Wallet className="w-4 h-4" />
                  Connect Wallet
                </button>
                
                {showWalletOptions && (
                  <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-purple-500/30 rounded-lg shadow-xl overflow-hidden">
                    <button 
                      onClick={connectMetaMask}
                      className="w-full px-4 py-3 hover:bg-purple-500/20 transition text-left flex items-center gap-3">
                      <span className="text-xl">🦊</span>
                      MetaMask
                    </button>
                    <button 
                      onClick={connectWalletConnect}
                      className="w-full px-4 py-3 hover:bg-purple-500/20 transition text-left flex items-center gap-3">
                      <span className="text-xl">🔗</span>
                      WalletConnect
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </header>
        
                                                                                                                                               


      {/* Hero Section */}
      <section className="container mx-auto px-4 py-12 text-center">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent">
          Mint Across Multiple Chains
        </h1>
        <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
          Choose from 12 exclusive NFT collections - each automatically mints on its dedicated blockchain
        </p>
        {!isWalletConnected && (
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-500/20 border border-yellow-500/50 rounded-lg text-yellow-300 text-sm">
            ⚠️ Connect your wallet to start minting
          </div>
        )}
      </section>

      






      {/* Collections Grid */}
      <section className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold mb-8 text-center">NFT Collections</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {collections.map((collection, idx) => {
            const chainInfo = chains[collection.chain];
            const mintedSupply = supplies[idx] || '0';
            
            return (
              <div
                key={idx}
                onClick={() => {
                  setSelectedCollection(idx);
                  fetchSupply(idx);
                }}
                className={`bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 cursor-pointer transition-all hover:scale-105 ${
                  selectedCollection === idx ? 'ring-4 ring-purple-500 shadow-2xl shadow-purple-500/50' : ''
                }`}>
                <div className="mb-4 flex justify-center">
  <img 
    src={collection.image} 
    alt={collection.name}
    className="w-32 h-32 rounded-xl object-cover"
    onError={(e) => {
      // Fallback to emoji if image fails to load
      e.target.style.display = 'none';
      e.target.nextSibling.style.display = 'block';
    }}
  />
  <div className="text-6xl text-center hidden">
    {collection.image.startsWith('http') ? '🎨' : collection.image}
  </div>
</div>
                <h3 className="text-xl font-bold mb-2">{collection.name}</h3>
                <div className="flex justify-between text-gray-400 text-sm mb-2">
                  <span>Price: {collection.price}</span>
                  <span>
                    {isLoadingSupply && !supplies[idx] ? (
                      'Loading...'
                    ) : (
                      `Minted: ${mintedSupply} / ${collection.supply}`
                    )}
                  </span>
                </div>
                <div className={`inline-block px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${chainInfo.color} mb-4`}>
                  {chainInfo.name}
                </div>
                {selectedCollection === idx && (
                  <div className="mt-4 pt-4 border-t border-purple-500/30">
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-sm text-gray-400">Amount:</span>
                      <div className="flex items-center gap-3">
                        <button 
                          onClick={(e) => { e.stopPropagation(); setMintAmount(Math.max(1, mintAmount - 1)); }}
                          className="w-8 h-8 bg-purple-500/20 rounded-lg hover:bg-purple-500/40 transition flex items-center justify-center"
                          disabled={isMinting}>
                          <Minus className="w-4 h-4" />
                        </button>
                        <span className="font-bold w-8 text-center">{mintAmount}</span>
                        <button 
                          onClick={(e) => { e.stopPropagation(); setMintAmount(Math.min(10, mintAmount + 1)); }}
                          className="w-8 h-8 bg-purple-500/20 rounded-lg hover:bg-purple-500/40 transition flex items-center justify-center"
                          disabled={isMinting}>
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                    <div className="text-xs text-gray-400 mb-3 text-center">
                      Total: {(parseFloat(collection.price) * mintAmount).toFixed(3)} ETH + gas
                    </div>
                    
                    



                       <button 
           onClick={(e) => { e.stopPropagation(); handleMint(); }}
  disabled={isMinting}
  className="w-full py-3 bg-gradient-to-r from-gray-700 to-zinc-600 rounded-lg font-semibold hover:scale-105 transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
  {isMinting ? (
    <>
      <Loader className="w-4 h-4 animate-spin" />
      Processing...
    </>
  ) : (
    `Mint on ${chainInfo.name}`
  )}
    
 </button>





                                                                                                                                                                
                    
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold mb-8 text-center">Frequently Asked Questions</h2>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white/5 rounded-xl overflow-hidden border border-purple-500/20">
              <button
                onClick={() => setExpandedFaq(expandedFaq === idx ? null : idx)}
                className="w-full px-6 py-4 flex justify-between items-center hover:bg-white/5 transition text-left">
                <span className="font-semibold">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 transition-transform ${expandedFaq === idx ? 'rotate-180' : ''}`} />
              </button>
              {expandedFaq === idx && (
                <div className="px-6 pb-4 text-gray-300">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-purple-500/20 mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400"> JUST MiNT . NFT Minting Platform.</p>
              <p className="text-sm text-gray-500 mt-1">Powered by multichain technology</p>
            </div>
            <div className="flex gap-4 text-sm">
              <a href="terms.html" target="_blank" className="text-gray-400 hover:text-purple-400 transition">Terms of Service</a>
              <a href="privacy.html" target="_blank" className="text-gray-400 hover:text-purple-400 transition">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-purple-400 transition"> </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NFTMintingPlatform;















































































































































































































































































































































    





